// extracted by mini-css-extract-plugin
export default {"icon":"mnGB","small":"bgHt","large":"jG0e","nudgeUp":"bt2x","nudgeDown":"yaPS","text-padded-right":"F5Up","textPaddedRight":"F5Up","text-padded-left":"x_AG","textPaddedLeft":"x_AG"};